// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InstallRouteImport } from './routes/install'
import { Route as StewardRouteImport } from './routes/_steward'
import { Route as RootLayoutRouteImport } from './routes/_rootLayout'
import { Route as LandingRouteImport } from './routes/_landing'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as StewardUpdateRouteImport } from './routes/_steward.update'
import { Route as StewardTermsRouteImport } from './routes/_steward.terms'
import { Route as StewardPrivacyRouteImport } from './routes/_steward.privacy'
import { Route as StewardDocsRouteImport } from './routes/_steward.docs'
import { Route as StewardAcceptableUseRouteImport } from './routes/_steward.acceptable-use'
import { Route as RootLayoutSignupRouteImport } from './routes/_rootLayout.signup'
import { Route as RootLayoutSignoutRouteImport } from './routes/_rootLayout.signout'
import { Route as RootLayoutSigninRouteImport } from './routes/_rootLayout.signin'
import { Route as LandingIndexRouteImport } from './routes/_landing.index'
import { Route as LandingPricingRouteImport } from './routes/_landing.pricing'
import { Route as LandingModelsRouteImport } from './routes/_landing.models'
import { Route as LandingLinkedinRouteImport } from './routes/_landing.linkedin'
import { Route as LandingDesignRouteImport } from './routes/_landing.design'
import { Route as LandingCliPickerRouteImport } from './routes/_landing.cli-picker'
import { Route as LandingAffiliatesRouteImport } from './routes/_landing.affiliates'
import { Route as LandingLocaleRouteImport } from './routes/_landing.$locale'
import { Route as StewardDocsIndexRouteImport } from './routes/_steward.docs.index'
import { Route as StewardDocsSlugRouteImport } from './routes/_steward.docs.$slug'
import { Route as RootLayoutInviteAcceptRouteImport } from './routes/_rootLayout.invite.accept'
import { Route as LandingBlogIndexRouteImport } from './routes/_landing.blog.index'
import { Route as LandingTopupSuccessRouteImport } from './routes/_landing.topup.success'
import { Route as LandingPlatformSlugRouteImport } from './routes/_landing.platform.$slug'
import { Route as LandingFeatureSlugRouteImport } from './routes/_landing.feature.$slug'
import { Route as LandingBlogSlugRouteImport } from './routes/_landing.blog.$slug'
import { Route as LandingLocaleIndexRouteImport } from './routes/_landing.$locale.index'
import { Route as AuthenticatedwondaWondaRouteImport } from './routes/_authenticated/(wonda)/_wonda'
import { Route as AuthenticatedstudioWelcomeRouteImport } from './routes/_authenticated/(studio)/welcome'
import { Route as AuthenticatedadminAdminRouteRouteImport } from './routes/_authenticated/(admin)/admin.route'
import { Route as LandingLocaleBlogIndexRouteImport } from './routes/_landing.$locale.blog.index'
import { Route as LandingLocalePlatformSlugRouteImport } from './routes/_landing.$locale.platform.$slug'
import { Route as LandingLocaleBlogSlugRouteImport } from './routes/_landing.$locale.blog.$slug'
import { Route as AuthenticatedwondaWondaSetupRouteImport } from './routes/_authenticated/(wonda)/_wonda.setup'
import { Route as AuthenticatedwondaWondaOnboardingRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding'
import { Route as AuthenticatedwondaWondaLinkRouteImport } from './routes/_authenticated/(wonda)/_wonda.link'
import { Route as AuthenticatedwondaWondaDownloadRouteImport } from './routes/_authenticated/(wonda)/_wonda.download'
import { Route as AuthenticatedwondaWondaCliAuthRouteImport } from './routes/_authenticated/(wonda)/_wonda.cli-auth'
import { Route as AuthenticatedwondaWondaCalendarRouteImport } from './routes/_authenticated/(wonda)/_wonda.calendar'
import { Route as AuthenticatedwondaWondaAccountRouteImport } from './routes/_authenticated/(wonda)/_wonda.account'
import { Route as AuthenticatedadminAdminIndexRouteImport } from './routes/_authenticated/(admin)/admin.index'
import { Route as AuthenticatedadminAdminUsersRouteImport } from './routes/_authenticated/(admin)/admin.users'
import { Route as AuthenticatedadminAdminSubscriptionCheckoutRouteImport } from './routes/_authenticated/(admin)/admin.subscription-checkout'
import { Route as AuthenticatedadminAdminStylesRouteImport } from './routes/_authenticated/(admin)/admin.styles'
import { Route as AuthenticatedadminAdminStyleImportsRouteImport } from './routes/_authenticated/(admin)/admin.style-imports'
import { Route as AuthenticatedadminAdminScrapeRouteImport } from './routes/_authenticated/(admin)/admin.scrape'
import { Route as AuthenticatedadminAdminOrganizationsRouteImport } from './routes/_authenticated/(admin)/admin.organizations'
import { Route as AuthenticatedadminAdminMailingRouteImport } from './routes/_authenticated/(admin)/admin.mailing'
import { Route as AuthenticatedadminAdminInviteLinksRouteImport } from './routes/_authenticated/(admin)/admin.invite-links'
import { Route as AuthenticatedadminAdminCostsRouteImport } from './routes/_authenticated/(admin)/admin.costs'
import { Route as AuthenticatedadminAdminComfyuiWorkersRouteImport } from './routes/_authenticated/(admin)/admin.comfyui-workers'
import { Route as AuthenticatedadminAdminBillingPlansRouteImport } from './routes/_authenticated/(admin)/admin.billing-plans'
import { Route as AuthenticatedadminAdminAppSettingsRouteImport } from './routes/_authenticated/(admin)/admin.app-settings'
import { Route as AuthenticatedadminAdminApifyQueueRouteImport } from './routes/_authenticated/(admin)/admin.apify-queue'
import { Route as AuthenticatedadminAdminAgentsRouteImport } from './routes/_authenticated/(admin)/admin.agents'
import { Route as AuthenticatedwondaWondaOrgsIndexRouteImport } from './routes/_authenticated/(wonda)/_wonda.orgs.index'
import { Route as AuthenticatedwondaWondaOrganizationsIndexRouteImport } from './routes/_authenticated/(wonda)/_wonda.organizations.index'
import { Route as AuthenticatedwondaWondaPublishTiktokRouteImport } from './routes/_authenticated/(wonda)/_wonda.publish.tiktok'
import { Route as AuthenticatedwondaWondaOrgsSlugRouteImport } from './routes/_authenticated/(wonda)/_wonda.orgs.$slug'
import { Route as AuthenticatedwondaWondaOrganizationsSlugRouteImport } from './routes/_authenticated/(wonda)/_wonda.organizations.$slug'
import { Route as AuthenticatedwondaWondaOauthConsentRouteImport } from './routes/_authenticated/(wonda)/_wonda.oauth.consent'
import { Route as AuthenticatedwondaWondaOnboardingIndexRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding.index'
import { Route as AuthenticatedwondaWondaOnboardingToolsRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding.tools'
import { Route as AuthenticatedwondaWondaOnboardingPlatformsRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding.platforms'
import { Route as AuthenticatedwondaWondaOnboardingPaywallRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding.paywall'
import { Route as AuthenticatedwondaWondaOnboardingGuideRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding.guide'
import { Route as AuthenticatedwondaWondaAccountIndexRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.index'
import { Route as AuthenticatedwondaWondaAccountTwinsRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.twins'
import { Route as AuthenticatedwondaWondaAccountSetupRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.setup'
import { Route as AuthenticatedwondaWondaAccountPlanRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.plan'
import { Route as AuthenticatedwondaWondaAccountOrganizationsRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.organizations'
import { Route as AuthenticatedwondaWondaAccountInvoicesRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.invoices'
import { Route as AuthenticatedwondaWondaAccountInviteRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.invite'
import { Route as AuthenticatedwondaWondaAccountGenerationsRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.generations'
import { Route as AuthenticatedwondaWondaAccountConnectedAppsRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.connected-apps'
import { Route as AuthenticatedwondaWondaAccountApiKeyRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.api-key'
import { Route as AuthenticatedwondaWondaAccountAccountsRouteImport } from './routes/_authenticated/(wonda)/_wonda.account.accounts'
import { Route as AuthenticatedwondaWondaPublishTiktokIndexRouteImport } from './routes/_authenticated/(wonda)/_wonda.publish.tiktok.index'
import { Route as AuthenticatedwondaWondaOnboardingGuideLinkedinRouteImport } from './routes/_authenticated/(wonda)/_wonda.onboarding.guide_.linkedin'
import { Route as AuthenticatedwondaWondaPublishTiktokTiktokAccountIdMediaIdRouteImport } from './routes/_authenticated/(wonda)/_wonda.publish.tiktok.$tiktokAccountId.$mediaId'

const InstallRoute = InstallRouteImport.update({
            id: '/install',path: '/install',getParentRoute: () => rootRouteImport
          })
const StewardRoute = StewardRouteImport.update({
            id: '/_steward',getParentRoute: () => rootRouteImport
          })
const RootLayoutRoute = RootLayoutRouteImport.update({
            id: '/_rootLayout',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/_landing',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const StewardUpdateRoute = StewardUpdateRouteImport.update({
            id: '/update',path: '/update',getParentRoute: () => StewardRoute
          })
const StewardTermsRoute = StewardTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => StewardRoute
          })
const StewardPrivacyRoute = StewardPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => StewardRoute
          })
const StewardDocsRoute = StewardDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => StewardRoute
          })
const StewardAcceptableUseRoute = StewardAcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => StewardRoute
          })
const RootLayoutSignupRoute = RootLayoutSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => RootLayoutRoute
          })
const RootLayoutSignoutRoute = RootLayoutSignoutRouteImport.update({
            id: '/signout',path: '/signout',getParentRoute: () => RootLayoutRoute
          })
const RootLayoutSigninRoute = RootLayoutSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => RootLayoutRoute
          })
const LandingIndexRoute = LandingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LandingRoute
          })
const LandingPricingRoute = LandingPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => LandingRoute
          })
const LandingModelsRoute = LandingModelsRouteImport.update({
            id: '/models',path: '/models',getParentRoute: () => LandingRoute
          })
const LandingLinkedinRoute = LandingLinkedinRouteImport.update({
            id: '/linkedin',path: '/linkedin',getParentRoute: () => LandingRoute
          })
const LandingDesignRoute = LandingDesignRouteImport.update({
            id: '/design',path: '/design',getParentRoute: () => LandingRoute
          })
const LandingCliPickerRoute = LandingCliPickerRouteImport.update({
            id: '/cli-picker',path: '/cli-picker',getParentRoute: () => LandingRoute
          })
const LandingAffiliatesRoute = LandingAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => LandingRoute
          })
const LandingLocaleRoute = LandingLocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => LandingRoute
          })
const StewardDocsIndexRoute = StewardDocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StewardDocsRoute
          })
const StewardDocsSlugRoute = StewardDocsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => StewardDocsRoute
          })
const RootLayoutInviteAcceptRoute = RootLayoutInviteAcceptRouteImport.update({
            id: '/invite/accept',path: '/invite/accept',getParentRoute: () => RootLayoutRoute
          })
const LandingBlogIndexRoute = LandingBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LandingRoute
          })
const LandingTopupSuccessRoute = LandingTopupSuccessRouteImport.update({
            id: '/topup/success',path: '/topup/success',getParentRoute: () => LandingRoute
          })
const LandingPlatformSlugRoute = LandingPlatformSlugRouteImport.update({
            id: '/platform/$slug',path: '/platform/$slug',getParentRoute: () => LandingRoute
          })
const LandingFeatureSlugRoute = LandingFeatureSlugRouteImport.update({
            id: '/feature/$slug',path: '/feature/$slug',getParentRoute: () => LandingRoute
          })
const LandingBlogSlugRoute = LandingBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LandingRoute
          })
const LandingLocaleIndexRoute = LandingLocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LandingLocaleRoute
          })
const AuthenticatedwondaWondaRoute = AuthenticatedwondaWondaRouteImport.update({
            id: '/(wonda)/_wonda',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedstudioWelcomeRoute = AuthenticatedstudioWelcomeRouteImport.update({
            id: '/(studio)/welcome',path: '/welcome',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedadminAdminRouteRoute = AuthenticatedadminAdminRouteRouteImport.update({
            id: '/(admin)/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const LandingLocaleBlogIndexRoute = LandingLocaleBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LandingLocaleRoute
          })
const LandingLocalePlatformSlugRoute = LandingLocalePlatformSlugRouteImport.update({
            id: '/platform/$slug',path: '/platform/$slug',getParentRoute: () => LandingLocaleRoute
          })
const LandingLocaleBlogSlugRoute = LandingLocaleBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LandingLocaleRoute
          })
const AuthenticatedwondaWondaSetupRoute = AuthenticatedwondaWondaSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaOnboardingRoute = AuthenticatedwondaWondaOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaLinkRoute = AuthenticatedwondaWondaLinkRouteImport.update({
            id: '/link',path: '/link',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaDownloadRoute = AuthenticatedwondaWondaDownloadRouteImport.update({
            id: '/download',path: '/download',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaCliAuthRoute = AuthenticatedwondaWondaCliAuthRouteImport.update({
            id: '/cli-auth',path: '/cli-auth',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaCalendarRoute = AuthenticatedwondaWondaCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaAccountRoute = AuthenticatedwondaWondaAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedadminAdminIndexRoute = AuthenticatedadminAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminUsersRoute = AuthenticatedadminAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminSubscriptionCheckoutRoute = AuthenticatedadminAdminSubscriptionCheckoutRouteImport.update({
            id: '/subscription-checkout',path: '/subscription-checkout',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminStylesRoute = AuthenticatedadminAdminStylesRouteImport.update({
            id: '/styles',path: '/styles',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminStyleImportsRoute = AuthenticatedadminAdminStyleImportsRouteImport.update({
            id: '/style-imports',path: '/style-imports',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminScrapeRoute = AuthenticatedadminAdminScrapeRouteImport.update({
            id: '/scrape',path: '/scrape',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminOrganizationsRoute = AuthenticatedadminAdminOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminMailingRoute = AuthenticatedadminAdminMailingRouteImport.update({
            id: '/mailing',path: '/mailing',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminInviteLinksRoute = AuthenticatedadminAdminInviteLinksRouteImport.update({
            id: '/invite-links',path: '/invite-links',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminCostsRoute = AuthenticatedadminAdminCostsRouteImport.update({
            id: '/costs',path: '/costs',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminComfyuiWorkersRoute = AuthenticatedadminAdminComfyuiWorkersRouteImport.update({
            id: '/comfyui-workers',path: '/comfyui-workers',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminBillingPlansRoute = AuthenticatedadminAdminBillingPlansRouteImport.update({
            id: '/billing-plans',path: '/billing-plans',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminAppSettingsRoute = AuthenticatedadminAdminAppSettingsRouteImport.update({
            id: '/app-settings',path: '/app-settings',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminApifyQueueRoute = AuthenticatedadminAdminApifyQueueRouteImport.update({
            id: '/apify-queue',path: '/apify-queue',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedadminAdminAgentsRoute = AuthenticatedadminAdminAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AuthenticatedadminAdminRouteRoute
          })
const AuthenticatedwondaWondaOrgsIndexRoute = AuthenticatedwondaWondaOrgsIndexRouteImport.update({
            id: '/orgs/',path: '/orgs/',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaOrganizationsIndexRoute = AuthenticatedwondaWondaOrganizationsIndexRouteImport.update({
            id: '/organizations/',path: '/organizations/',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaPublishTiktokRoute = AuthenticatedwondaWondaPublishTiktokRouteImport.update({
            id: '/publish/tiktok',path: '/publish/tiktok',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaOrgsSlugRoute = AuthenticatedwondaWondaOrgsSlugRouteImport.update({
            id: '/orgs/$slug',path: '/orgs/$slug',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaOrganizationsSlugRoute = AuthenticatedwondaWondaOrganizationsSlugRouteImport.update({
            id: '/organizations/$slug',path: '/organizations/$slug',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaOauthConsentRoute = AuthenticatedwondaWondaOauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => AuthenticatedwondaWondaRoute
          })
const AuthenticatedwondaWondaOnboardingIndexRoute = AuthenticatedwondaWondaOnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedwondaWondaOnboardingRoute
          })
const AuthenticatedwondaWondaOnboardingToolsRoute = AuthenticatedwondaWondaOnboardingToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AuthenticatedwondaWondaOnboardingRoute
          })
const AuthenticatedwondaWondaOnboardingPlatformsRoute = AuthenticatedwondaWondaOnboardingPlatformsRouteImport.update({
            id: '/platforms',path: '/platforms',getParentRoute: () => AuthenticatedwondaWondaOnboardingRoute
          })
const AuthenticatedwondaWondaOnboardingPaywallRoute = AuthenticatedwondaWondaOnboardingPaywallRouteImport.update({
            id: '/paywall',path: '/paywall',getParentRoute: () => AuthenticatedwondaWondaOnboardingRoute
          })
const AuthenticatedwondaWondaOnboardingGuideRoute = AuthenticatedwondaWondaOnboardingGuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => AuthenticatedwondaWondaOnboardingRoute
          })
const AuthenticatedwondaWondaAccountIndexRoute = AuthenticatedwondaWondaAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountTwinsRoute = AuthenticatedwondaWondaAccountTwinsRouteImport.update({
            id: '/twins',path: '/twins',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountSetupRoute = AuthenticatedwondaWondaAccountSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountPlanRoute = AuthenticatedwondaWondaAccountPlanRouteImport.update({
            id: '/plan',path: '/plan',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountOrganizationsRoute = AuthenticatedwondaWondaAccountOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountInvoicesRoute = AuthenticatedwondaWondaAccountInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountInviteRoute = AuthenticatedwondaWondaAccountInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountGenerationsRoute = AuthenticatedwondaWondaAccountGenerationsRouteImport.update({
            id: '/generations',path: '/generations',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountConnectedAppsRoute = AuthenticatedwondaWondaAccountConnectedAppsRouteImport.update({
            id: '/connected-apps',path: '/connected-apps',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountApiKeyRoute = AuthenticatedwondaWondaAccountApiKeyRouteImport.update({
            id: '/api-key',path: '/api-key',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaAccountAccountsRoute = AuthenticatedwondaWondaAccountAccountsRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => AuthenticatedwondaWondaAccountRoute
          })
const AuthenticatedwondaWondaPublishTiktokIndexRoute = AuthenticatedwondaWondaPublishTiktokIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedwondaWondaPublishTiktokRoute
          })
const AuthenticatedwondaWondaOnboardingGuideLinkedinRoute = AuthenticatedwondaWondaOnboardingGuideLinkedinRouteImport.update({
            id: '/guide_/linkedin',path: '/guide/linkedin',getParentRoute: () => AuthenticatedwondaWondaOnboardingRoute
          })
const AuthenticatedwondaWondaPublishTiktokTiktokAccountIdMediaIdRoute = AuthenticatedwondaWondaPublishTiktokTiktokAccountIdMediaIdRouteImport.update({
            id: '/$tiktokAccountId/$mediaId',path: '/$tiktokAccountId/$mediaId',getParentRoute: () => AuthenticatedwondaWondaPublishTiktokRoute
          })





const AuthenticatedadminAdminRouteRouteChildren = {
  AuthenticatedadminAdminAgentsRoute: AuthenticatedadminAdminAgentsRoute,AuthenticatedadminAdminApifyQueueRoute: AuthenticatedadminAdminApifyQueueRoute,AuthenticatedadminAdminAppSettingsRoute: AuthenticatedadminAdminAppSettingsRoute,AuthenticatedadminAdminBillingPlansRoute: AuthenticatedadminAdminBillingPlansRoute,AuthenticatedadminAdminComfyuiWorkersRoute: AuthenticatedadminAdminComfyuiWorkersRoute,AuthenticatedadminAdminCostsRoute: AuthenticatedadminAdminCostsRoute,AuthenticatedadminAdminInviteLinksRoute: AuthenticatedadminAdminInviteLinksRoute,AuthenticatedadminAdminMailingRoute: AuthenticatedadminAdminMailingRoute,AuthenticatedadminAdminOrganizationsRoute: AuthenticatedadminAdminOrganizationsRoute,AuthenticatedadminAdminScrapeRoute: AuthenticatedadminAdminScrapeRoute,AuthenticatedadminAdminStyleImportsRoute: AuthenticatedadminAdminStyleImportsRoute,AuthenticatedadminAdminStylesRoute: AuthenticatedadminAdminStylesRoute,AuthenticatedadminAdminSubscriptionCheckoutRoute: AuthenticatedadminAdminSubscriptionCheckoutRoute,AuthenticatedadminAdminUsersRoute: AuthenticatedadminAdminUsersRoute,AuthenticatedadminAdminIndexRoute: AuthenticatedadminAdminIndexRoute
}

const AuthenticatedadminAdminRouteRouteWithChildren = AuthenticatedadminAdminRouteRoute._addFileChildren(AuthenticatedadminAdminRouteRouteChildren)




const AuthenticatedwondaWondaAccountRouteChildren = {
  AuthenticatedwondaWondaAccountAccountsRoute: AuthenticatedwondaWondaAccountAccountsRoute,AuthenticatedwondaWondaAccountApiKeyRoute: AuthenticatedwondaWondaAccountApiKeyRoute,AuthenticatedwondaWondaAccountConnectedAppsRoute: AuthenticatedwondaWondaAccountConnectedAppsRoute,AuthenticatedwondaWondaAccountGenerationsRoute: AuthenticatedwondaWondaAccountGenerationsRoute,AuthenticatedwondaWondaAccountInviteRoute: AuthenticatedwondaWondaAccountInviteRoute,AuthenticatedwondaWondaAccountInvoicesRoute: AuthenticatedwondaWondaAccountInvoicesRoute,AuthenticatedwondaWondaAccountOrganizationsRoute: AuthenticatedwondaWondaAccountOrganizationsRoute,AuthenticatedwondaWondaAccountPlanRoute: AuthenticatedwondaWondaAccountPlanRoute,AuthenticatedwondaWondaAccountSetupRoute: AuthenticatedwondaWondaAccountSetupRoute,AuthenticatedwondaWondaAccountTwinsRoute: AuthenticatedwondaWondaAccountTwinsRoute,AuthenticatedwondaWondaAccountIndexRoute: AuthenticatedwondaWondaAccountIndexRoute
}

const AuthenticatedwondaWondaAccountRouteWithChildren = AuthenticatedwondaWondaAccountRoute._addFileChildren(AuthenticatedwondaWondaAccountRouteChildren)




const AuthenticatedwondaWondaOnboardingRouteChildren = {
  AuthenticatedwondaWondaOnboardingGuideRoute: AuthenticatedwondaWondaOnboardingGuideRoute,AuthenticatedwondaWondaOnboardingPaywallRoute: AuthenticatedwondaWondaOnboardingPaywallRoute,AuthenticatedwondaWondaOnboardingPlatformsRoute: AuthenticatedwondaWondaOnboardingPlatformsRoute,AuthenticatedwondaWondaOnboardingToolsRoute: AuthenticatedwondaWondaOnboardingToolsRoute,AuthenticatedwondaWondaOnboardingIndexRoute: AuthenticatedwondaWondaOnboardingIndexRoute,AuthenticatedwondaWondaOnboardingGuideLinkedinRoute: AuthenticatedwondaWondaOnboardingGuideLinkedinRoute
}

const AuthenticatedwondaWondaOnboardingRouteWithChildren = AuthenticatedwondaWondaOnboardingRoute._addFileChildren(AuthenticatedwondaWondaOnboardingRouteChildren)




const AuthenticatedwondaWondaPublishTiktokRouteChildren = {
  AuthenticatedwondaWondaPublishTiktokIndexRoute: AuthenticatedwondaWondaPublishTiktokIndexRoute,AuthenticatedwondaWondaPublishTiktokTiktokAccountIdMediaIdRoute: AuthenticatedwondaWondaPublishTiktokTiktokAccountIdMediaIdRoute
}

const AuthenticatedwondaWondaPublishTiktokRouteWithChildren = AuthenticatedwondaWondaPublishTiktokRoute._addFileChildren(AuthenticatedwondaWondaPublishTiktokRouteChildren)



const AuthenticatedwondaWondaRouteChildren = {
  AuthenticatedwondaWondaAccountRoute: AuthenticatedwondaWondaAccountRouteWithChildren,AuthenticatedwondaWondaCalendarRoute: AuthenticatedwondaWondaCalendarRoute,AuthenticatedwondaWondaCliAuthRoute: AuthenticatedwondaWondaCliAuthRoute,AuthenticatedwondaWondaDownloadRoute: AuthenticatedwondaWondaDownloadRoute,AuthenticatedwondaWondaLinkRoute: AuthenticatedwondaWondaLinkRoute,AuthenticatedwondaWondaOnboardingRoute: AuthenticatedwondaWondaOnboardingRouteWithChildren,AuthenticatedwondaWondaSetupRoute: AuthenticatedwondaWondaSetupRoute,AuthenticatedwondaWondaOauthConsentRoute: AuthenticatedwondaWondaOauthConsentRoute,AuthenticatedwondaWondaOrganizationsSlugRoute: AuthenticatedwondaWondaOrganizationsSlugRoute,AuthenticatedwondaWondaOrgsSlugRoute: AuthenticatedwondaWondaOrgsSlugRoute,AuthenticatedwondaWondaPublishTiktokRoute: AuthenticatedwondaWondaPublishTiktokRouteWithChildren,AuthenticatedwondaWondaOrganizationsIndexRoute: AuthenticatedwondaWondaOrganizationsIndexRoute,AuthenticatedwondaWondaOrgsIndexRoute: AuthenticatedwondaWondaOrgsIndexRoute
}

const AuthenticatedwondaWondaRouteWithChildren = AuthenticatedwondaWondaRoute._addFileChildren(AuthenticatedwondaWondaRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedadminAdminRouteRoute: AuthenticatedadminAdminRouteRouteWithChildren,AuthenticatedstudioWelcomeRoute: AuthenticatedstudioWelcomeRoute,AuthenticatedwondaWondaRoute: AuthenticatedwondaWondaRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const LandingLocaleRouteChildren = {
  LandingLocaleIndexRoute: LandingLocaleIndexRoute,LandingLocaleBlogSlugRoute: LandingLocaleBlogSlugRoute,LandingLocalePlatformSlugRoute: LandingLocalePlatformSlugRoute,LandingLocaleBlogIndexRoute: LandingLocaleBlogIndexRoute
}

const LandingLocaleRouteWithChildren = LandingLocaleRoute._addFileChildren(LandingLocaleRouteChildren)



const LandingRouteChildren = {
  LandingLocaleRoute: LandingLocaleRouteWithChildren,LandingAffiliatesRoute: LandingAffiliatesRoute,LandingCliPickerRoute: LandingCliPickerRoute,LandingDesignRoute: LandingDesignRoute,LandingLinkedinRoute: LandingLinkedinRoute,LandingModelsRoute: LandingModelsRoute,LandingPricingRoute: LandingPricingRoute,LandingIndexRoute: LandingIndexRoute,LandingBlogSlugRoute: LandingBlogSlugRoute,LandingFeatureSlugRoute: LandingFeatureSlugRoute,LandingPlatformSlugRoute: LandingPlatformSlugRoute,LandingTopupSuccessRoute: LandingTopupSuccessRoute,LandingBlogIndexRoute: LandingBlogIndexRoute
}

const LandingRouteWithChildren = LandingRoute._addFileChildren(LandingRouteChildren)




const RootLayoutRouteChildren = {
  RootLayoutSigninRoute: RootLayoutSigninRoute,RootLayoutSignoutRoute: RootLayoutSignoutRoute,RootLayoutSignupRoute: RootLayoutSignupRoute,RootLayoutInviteAcceptRoute: RootLayoutInviteAcceptRoute
}

const RootLayoutRouteWithChildren = RootLayoutRoute._addFileChildren(RootLayoutRouteChildren)




const StewardDocsRouteChildren = {
  StewardDocsSlugRoute: StewardDocsSlugRoute,StewardDocsIndexRoute: StewardDocsIndexRoute
}

const StewardDocsRouteWithChildren = StewardDocsRoute._addFileChildren(StewardDocsRouteChildren)



const StewardRouteChildren = {
  StewardAcceptableUseRoute: StewardAcceptableUseRoute,StewardDocsRoute: StewardDocsRouteWithChildren,StewardPrivacyRoute: StewardPrivacyRoute,StewardTermsRoute: StewardTermsRoute,StewardUpdateRoute: StewardUpdateRoute
}

const StewardRouteWithChildren = StewardRoute._addFileChildren(StewardRouteChildren)

const rootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,LandingRoute: LandingRouteWithChildren,RootLayoutRoute: RootLayoutRouteWithChildren,StewardRoute: StewardRouteWithChildren,InstallRoute: InstallRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)